import { render, staticRenderFns } from "./EBreadcrumbs.vue?vue&type=template&id=b20790e2&scoped=true"
import script from "./EBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./EBreadcrumbs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20790e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b20790e2')) {
      api.createRecord('b20790e2', component.options)
    } else {
      api.reload('b20790e2', component.options)
    }
    module.hot.accept("./EBreadcrumbs.vue?vue&type=template&id=b20790e2&scoped=true", function () {
      api.rerender('b20790e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/EBreadcrumbs.vue"
export default component.exports